import { useCallback, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { passwordConditions } from "../../helpers/password-validation-helper";
export function useResetPasswordState() {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const { formState: { errors, isValid }, handleSubmit: submitForm, register, watch, } = useForm({
        mode: "all",
        defaultValues: {
            password: "",
            confirmPassword: "",
        },
    });
    const password = watch("password");
    const confirmPassword = watch("confirmPassword");
    const { strength: passwordStrength, length: passwordLength, specialChars: passwordSpecialChars } = passwordConditions(password);
    const validLength = useMemo(() => passwordLength >= 8, [passwordLength]);
    const matchedPasswords = useMemo(() => password === confirmPassword, [password, confirmPassword]);
    const canSubmit = useMemo(() => !!isValid && !!validLength && ["Medium", "Strong"]?.includes(passwordStrength?.value) && matchedPasswords && !!passwordSpecialChars, [isValid, validLength, passwordStrength, passwordSpecialChars, matchedPasswords]);
    const handleBackClicked = useCallback(() => {
        navigate(-1);
    }, []);
    const handleTogglePassword = useCallback(() => {
        setShowPassword((prevValue) => !prevValue);
    }, []);
    const handleToggleConfirmPassword = useCallback(() => {
        setShowConfirmPassword((prevValue) => !prevValue);
    }, []);
    return useMemo(() => ({
        canSubmit,
        errors,
        handleBackClicked,
        handleTogglePassword,
        handleToggleConfirmPassword,
        passwordSpecialChars,
        register,
        showPassword,
        showConfirmPassword,
        submitForm,
        validLength,
    }), [
        canSubmit,
        errors,
        handleBackClicked,
        handleTogglePassword,
        handleToggleConfirmPassword,
        passwordSpecialChars,
        register,
        showPassword,
        showConfirmPassword,
        submitForm,
        validLength,
    ]);
}
